<template>
  <b-modal id="delete-org" centered hide-footer hide-header>
    <h3>Delete Organization</h3>
    <p>
      Are you sure you want to delete this organization? This action cannot be
      undone. Please type the organization name to confirm: "{{ org.name }}"
    </p>
    <form @submit.prevent="deleteOrg">
      <b-input v-model="confirmName" placeholder="Organization Name" />
      <div class="mt-4 text-right">
        <b-btn
          class="ml-2 px-4"
          variant="secondary"
          @click="$bvModal.hide('delete-org')"
        >
          Cancel
        </b-btn>
        <b-btn
          :disabled="confirmName !== org.name"
          class="ml-2 px-4"
          variant="danger"
          type="submit"
        >
          Delete
        </b-btn>
      </div>
    </form>
  </b-modal>
</template>

<script>
import API from "@/api";

export default {
  props: {
    org: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    confirmName: ""
  }),

  methods: {
    async deleteOrg() {
      const { success } = await API.deleteOrg(this.org.id);
      if (!success) return;

      this.$emit("updated");
      this.$notify({
        type: "success",
        text: "Organization deleted"
      });
      this.$bvModal.hide("delete-org");
    }
  }
};
</script>
